export default {
  state: {
    list: [],
    extends: [],
    info:[],
  },
  getters: {
    getInformation: state => {
      return state.info;
    },
    getInfo: state => code => {
      return state.info.find(item => item.code === code);
    },
    getProduct: state => code => {
      return state.list.find(item => item.code === code);
    },
    getProductExtend: state => code => {
      return state.extends.find(item => item.code === code);
    },
    /**
     * type:Number 分类，0:全部，1团险，2个险
     * includeProduct:Boolean 分类下是否包含产品信息
     */
    getCategoryList: state => (type, includeProduct) => {
      let categories = [];
      const products =
        type === 0
          ? state.list
          : state.list.filter(item => item.isGroup === (type === 1));

      products.forEach(element => {
        element.categories.forEach(category => {
          if (categories.findIndex(o => o.name === category) === -1) {
            categories.push({
              name: category
            });
          }
        });
      });
      if (includeProduct) {
        categories.forEach(category => {
          const categoryProducts = products.filter(item =>
            item.categories.includes(category.name)
          );
          categoryProducts.sort((a, b) => a.order - b.order);
          category.products = categoryProducts;
        });
      }
      return categories;
    }
  },
  mutations: {
    setList(state, val) {
      state.list = val;
    },
    setExtends(state, val) {
      state.extends = val;
    },
    setInfo(state, val) {
      state.info = val;
    }
  },
  actions: {
    async getProducts({ commit, state }) {
      return new Promise(resolve => {
        if (state.list && state.list.length > 0) {
          resolve(state.list);
        } else {
          this.$axios.get("/json/products.json").then(list => {
            commit("setList", list);
            resolve(list);
          });
        }
      });
    },
    async getProductExtends({ commit, state }) {
      return new Promise(resolve => {
        if (state.extends && state.extends.length > 0) {
          resolve(state.extends);
        } else {
          this.$axios.get("/json/productExtends.json").then(list => {
            commit("setExtends", list);
            resolve(list);
          });
        }
      });
    },
    async getInformations({ commit, state }) {
      return new Promise(resolve => {
        if (state.info && state.info.length > 0) {
          console.log(info)
          resolve(state.info);
        } else {
          this.$axios.get("/json/information.json").then(info => {
            console.log(info)
            commit("setInfo", info);
            resolve(info);
          });
        }
      });
    },
  }
};
